module.exports = __webpack_public_path__ + "img/pic_tk_content.238a7df0.png";